<template>
    <div class="cents">
        <van-nav-bar
        :title="$t('fxys')"
        left-arrow
        safe-area-inset-top
        style="background-color: #1ABC9C;"
        @click-left="goto"
        />
        <div class="contents">
            <div class="dispa">
                <p>{{$t('sssb')}}：</p>
                <div class="sheacdiv">
                    <input type="text" class="sheach" v-model="keyword">
                    <van-button color="#fff" @click="geteqList"  type="primary" size="mini">{{$t('cx')}}</van-button>
                </div>
            </div>
            <div class="dispa">
                <p>{{$t('xzsb')}}：</p>
                <select v-model="device_id">
                    <option :selected="true" value ="0">{{$t('wsb')}}</option>
                    <option :value ="item.device_id" v-for="item in eqlist2" :key="item.id">{{item.name}}</option> 
                    <!-- selected = "selected" -->
                </select>
            </div>
            <div class="dispa">
                <p>{{$t('fwcs')}}：</p>
                <select v-model="number">
                    <option :selected="true" value ="0">{{$t('bxcs')}}</option>
                    <option value ="5">{{$t('yc')}}</option>
                    <option value ="5">{{$t('lc')}}</option>
                </select>
            </div>
            <div class="dispa">
                <p>{{$t('fwyxq')}}：</p>
                <input type="text" v-model="tiemsc" @click="handTiems">
                <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
                    <van-datetime-picker
                    v-model="currentDate"
                    type="datetime"
                    :confirm-button-text="$t('qd')"
                    :cancel-button-text="$t('qx')"
                    :show-subtitle='false'
                    @confirm = 'confirm'
                    />
                </van-popup>
            </div>

            <div class="ewmcode">
                <vue-qr :size="210" :margin="10" :auto-color="true" :dot-scale="1" :text="appSrc" />
            </div>
            
        </div>
        <div class="buts" >
            <p>{{$t('qjzewmdzjt')}}</p>
            <van-button color="#1ABC9C" class="fenx" type="primary" @click="Share">{{$t('fxewm')}}</van-button>
			 <van-button color="#1ABC9C" class="fenx" type="primary" @click="Sharepaw">{{$t('fxmm')}}</van-button>
        </div>
        <!-- <button @click="handappSrc">是</button> -->
        <van-share-sheet
        v-model="showShare"
        :title="$t('ljfghy')"
        :options="options"
        :cancel-text="$t('qx')"
        @select="onSelect"
        />
		<!-- 分享密码 -->
	
		<van-dialog v-model="showPicker" :title="$t('fxmm')" :confirmButtonText="$t('qd')" :cancelButtonText="$t('qx')" show-cancel-button>
			<p style="margin-top: 10px;">门禁机码：{{this.decviname}}</p>
			<p style="margin-top: 10px;">安装位置：{{this.devicewz}}</p>
			<p style="margin-top: 10px;">开门密码：{{this.sharpaw}}</p>
			<p style="margin-top: 10px;">有效次数：{{this.numbernames}}</p>
			<p style="margin-top: 10px;">有效日期：{{this.tiemsc}}</p>
		</van-dialog>
    </div>
</template>
<script>
import VueQr from 'vue-qr'
import { formatDateTime } from "@/utils/index";
import { Toast } from 'vant';
export default {
    components:{
        VueQr
    },
    data(){
        return{
            showShare:false,
            options: [
                { name: this.$t('fzlj'), icon: 'link' },
            ],
            windowUrl : window.location.href,
            number:'0',
            keyword:'',
            eqlist:[],
            eqlist2:[],
            device_id:'0',
            appSrc:'F2/3788/22507/0/1631113080/1631004073',
            Userof:JSON.parse(window.localStorage.getItem('getTokendata')),
            tiemsc:null,

            show:false,
            currentDate: new Date(),
            lastime:"",
            startime:'',
			showPicker:false,
			sharpaw:'',
			decviname:'',
			devicewz:'',
			numbernames:''
        }
    },
    watch:{
        'number':function(news,old){
            if(news!=old){
                this.handappSrc()
            }
        },
        'tiemsc':function(news,old){
            if(news!=old){
                this.handappSrc()
            }
        },
        'device_id':function(news,old){
            if(news!=old){
                this.handappSrc()
            }
        }
    },
    mounted(){
        // this.geteqList()
        this.tiemsc =formatDateTime(new Date()) 
        this.geteqList2()
        this.handeldow()
    },
    methods:{
        // 分享
        Share(){
            this.showShare = true
        },
        onSelect(option) {
            var domUrl = document.createElement("input");
            domUrl.value = this.windowUrl;
            domUrl.id = "creatDom";
            document.body.appendChild(domUrl);
            domUrl.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            let creatDom = document.getElementById("creatDom");
            creatDom.parentNode.removeChild(creatDom);
            Toast(option.name+' '+this.$t('cg'));
            this.showShare = false;
        },
        // 时间线上
        handTiems(){
            this.show= true
        },
        confirm(){
            let Selectime = new Date(this.currentDate).getTime()/1000
            Selectime =  Math.floor(Selectime)
            let currentime = Date.parse(new Date())/1000
            // console.log(strtims,lastims)
            if(Selectime<currentime){
                Toast.fail(this.$t('bnzydqsj'))
                this.show = false
                return false
            }

            if(Selectime-currentime>24*60*60*7){
                Toast.fail(this.$t('yxqbn'))
                this.show = false
                return false
            }
            this.tiemsc = formatDateTime(this.currentDate)
            this.show = false
        },
        // 返回
        goto(){
            this.$router.go(-1)
        },
        // 设备列表
        geteqList(){
            let data ={
                method:'co.wx.device.list',
                user_id:this.Userof.user_id,
                page_index:1,
                page_size:999,
                keyword:this.keyword
            }
            this.$serve(data).then(res=>{
                if(res.data.code == 0){
                    this.eqlist = res.data.data
                }
            })
        },
        // 
        geteqList2(){
            let data ={
                method:'co.wx.share.key.device.list',
                user_id:this.Userof.user_id,
                device_id:this.device_id
            }
            this.$serve(data).then(res=>{
                console.log(res )
                if(res.data.code == 0){
                    this.eqlist2 = res.data.data
                }
            })
        },
        handeldow(){
            this.clearTimeSet=setInterval( () =>{
                this.handappSrc()
            }, 4000);
        },
        //拼接出appSrc 的值
        handappSrc(){
            this.lastime =  Date.parse(new Date())/1000;
            this.startime = new Date(this.currentDate).getTime()/1000
            this.startime = Math.floor(this.startime)
            console.log(this.startime)
            
            this.appSrc = 'F2/' + this.device_id +'/'+ this.Userof.user_id +'/'+ this.number +'/' + this.startime +'/'+this.lastime
            console.log(this.appSrc, )

        },
		// 分享密码
		
		Sharepaw(){
			if(this.device_id==0){
				Toast.fail(this.$t('qxzsb'))
				return false
			}
			this.eqlist2.forEach(el=>{
				if( el.device_id == this.device_id){
					this.decviname = el.serial_number
					this.devicewz = el.name
				}
			})
			if(this.number ==0 ){
				this.numbernames = "不限次数"
			}else if(this.number == 1){
				this.numbernames = "一次"
			}else{
				this.numbernames = "俩次"
			}
			let data ={
			    method:'co.wx.visitor.pwd.get',
			    agent_id:this.Userof.agent_id,
			    device_id:this.device_id
			}
			this.$serve(data).then(res=>{
			    console.log(res )
			    this.sharpaw = '999'+res.data.data+'#'
				this.showPicker = true
			})
		}


    },
    beforeDestroy() {    //页面关闭时清除定时器  
        clearInterval(this.clearTimeSet);
    },
}
</script>
<style scoped>
.contents{
    width: 80%;
    margin: 0 auto;
    margin-top: 30px;
}
.dispa{
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}
p{
    margin: 0;
    line-height: 25px;
}
.sheacdiv{
   
    border-radius: 3px;
    border: 1px solid #7F7F7F;
}
.sheacdiv .sheach{
    width: 135px;
    border: none;
    height: 32px;
}
.dispa input{
    width: 172px;
    height: 32px;
    padding:2px 5px;
    border: 1px solid #7F7F7F;
    border-radius: 3px;
}
.dispa select{
    height: 32px;
    width: 172px;
    border-radius:3px ;
    border: 1px solid #7F7F7F;
}
.dispa >>>.van-button__text{
    color: black;
}
.ewmcode{
    margin-top: 30px;
}

.buts{
    margin-top: 20px;
}
.fenx{
    width: 80%;
    margin-top: 10px;
    border-radius: 5px;
}
.fenx>>>.van-button__text{
    font-weight: bold;
}

.cents >>>.van-nav-bar__title{
    color: #fff;
}
.cents>>>.van-nav-bar .van-icon{
    color: #fff;
}
.centpop{
	width: 200px;
	height: 200px;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.centpop p{
	font-size: 16px;
	font-weight: 600;
	line-height: 28px;
}
</style>